import {PropType} from "vue";
import {AbstractTarifPrice} from "~/cabinet/vue/dealer/config/uslugi/tarif/common/price/AbstractTarifPrice";

export function useTarifPriceProps<PriceInterface extends AbstractTarifPrice>() {
    return {
        modelValue: {
            type: Object as PropType<PriceInterface>
        }
    }
}